import { render, staticRenderFns } from "./WebchatConfig.vue?vue&type=template&id=5ffc9ed6"
import script from "./WebchatConfig.vue?vue&type=script&lang=js"
export * from "./WebchatConfig.vue?vue&type=script&lang=js"
import style0 from "./WebchatConfig.vue?vue&type=style&index=0&id=5ffc9ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports